<script lang="ts">
import type { Temporal } from 'temporal-polyfill';
import type { TimeDisplayFormat } from '#layers/blocks/constants/date-time-display-options';
import type { DisplayBlockProps } from '#layers/blocks/types/display-block';
import { supportedTimeFieldTypes } from '#layers/blocks/blocks/Input/InputTime.block.vue';
import { TIME_DISPLAY_FORMAT_OPTIONS, TIME_DISPLAY_FORMAT_VALUES } from '#layers/blocks/constants/date-time-display-options';

interface DisplayFormattedTimeProps extends DisplayBlockProps<Temporal.PlainTime> {
	format?: TimeDisplayFormat;
}

const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_formatted_time.name',
	description: '$t:blocks.display_formatted_time.description',
	icon: 'lucide:clock',
	category: 'display',
	hidden: true,

	fieldBinding: {
		supportedTypes: supportedTimeFieldTypes,
	},

	options: [
		{
			name: 'value',
		},
		{
			name: 'format',
			description: '$t:blocks.date_time_display_options.format.description',
			block: '$builtin:InputSelect',
			type: 'enum',
			values: TIME_DISPLAY_FORMAT_VALUES,
			props: {
				options: TIME_DISPLAY_FORMAT_OPTIONS,
			},
		},
	],
}</script>

<script setup lang="ts">
import { computed } from 'vue';
import { formatPlainTime, isNil, useUserLocale } from '#layers/base/public';
import { defineBlock } from '#layers/block-engine/public';

const props = withDefaults(defineProps<DisplayFormattedTimeProps>(), {
	format: 'short',
});

;

const { formatLocale } = useUserLocale();

const formattedTime = computed(() => formatPlainTime(props.value, formatLocale.value, { timeStyle: props.format }));
</script>

<template>
	<DDisplayValueEmpty v-if="isNil(value)" />
	<div v-else>
		{{ formattedTime }}
	</div>
</template>
